const configStore = (() => {
    let config: any = {};
    const setAppConfigs = (configs: any) => config = configs;
    const getConfig = (key: string) => config[key];

    return { setAppConfigs, getConfig };
})();

export const setAppConfigs = configStore.setAppConfigs;
export const config = configStore.getConfig;
